import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LightingZoneGlyph = /*#__PURE__*/createElement("g", {
  id: "lighting_zone"
}, /*#__PURE__*/createElement("path", {
  d: "M41.49 69.19c-.22 0-.45-.05-.65-.15L15.16 56.58c-.56-.27-.9-.87-.84-1.49.06-.62.5-1.14 1.1-1.31l25.68-6.97c.25-.07.52-.07.77 0l26.69 6.97c.61.16 1.06.69 1.12 1.32.06.63-.29 1.23-.86 1.5L42.13 69.04c-.21.1-.42.15-.64.15zM20.07 55.62l21.43 10.4 22.27-10.4-22.27-5.81-21.43 5.81zm25.57-14.91h-7.28c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h7.28c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm0-3.78h-7.28c-.83 0-1.5-.67-1.5-1.5 0-1.4-.77-2.88-2.29-4.4-1.87-1.87-2.26-4.58-2.26-6.52 0-5.34 4.35-9.69 9.69-9.69s9.69 4.35 9.69 9.69c0 1.59-.29 4.56-2.26 6.52-1.52 1.52-2.29 3-2.29 4.4 0 .83-.67 1.5-1.5 1.5zm-5.94-3h4.61c.37-1.71 1.38-3.39 3.01-5.02.88-.88 1.38-2.48 1.38-4.4 0-3.69-3-6.69-6.69-6.69s-6.69 3-6.69 6.69c0 1.95.49 3.51 1.38 4.4 1.62 1.63 2.62 3.31 3 5.02zm5.94 7.42c0 1.33-1.08 2.41-2.41 2.41h-2.44c-1.33 0-2.41-1.08-2.41-2.41h7.26z"
}), /*#__PURE__*/createElement("path", {
  d: "M17.19 55.98l-2.6-1.5 2.5-4.33 2.6 1.5-2.5 4.33zm5-8.66l-2.6-1.5 2.5-4.33 2.6 1.5-2.5 4.33zm5.01-8.66l-2.6-1.5 2.5-4.33 2.6 1.5-2.5 4.33zm5-8.66l-2.6-1.5 1.65-2.86 2.6 1.5L32.2 30zm34.66 25.98l-2.5-4.33 2.6-1.5 2.5 4.33-2.6 1.5zm-5.01-8.66l-2.5-4.33 2.6-1.5 2.5 4.33-2.6 1.5zm-5-8.66l-2.5-4.33 2.6-1.5 2.5 4.33-2.6 1.5zm-5-8.66l-1.66-2.86 2.6-1.5 1.66 2.86-2.6 1.5z"
}));
const LightingZone = createSvg({
  name: 'lighting_zone',
  path: LightingZoneGlyph
});

export default LightingZone;
export { LightingZoneGlyph };
